module.exports = __webpack_public_path__ + "static/media/food.e5e1a83c.png";